var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M7.935 10.266V4.274l5.403 3.006zM19.8 3.236s-.196-1.47-.795-2.117c-.76-.85-1.613-.854-2.004-.903C14.203 0 10.004 0 10.004 0h-.008S5.797 0 2.999.216c-.391.05-1.243.053-2.005.903C.395 1.766.2 3.236.2 3.236S0 4.962 0 6.687v1.618c0 1.727.2 3.452.2 3.452s.195 1.47.794 2.117c.762.85 1.761.823 2.206.911C4.8 14.95 10 15 10 15s4.203-.007 7.001-.223c.39-.05 1.243-.054 2.004-.903.6-.647.795-2.117.795-2.117s.2-1.725.2-3.452V6.687c0-1.725-.2-3.451-.2-3.451"
  })));
};
export default SvgYoutube;